import React from "react";
import { motion } from "framer-motion";
import { SectionHeader, cx } from "@/components/site/primitives";
import { toast } from "@/components/ui/sonner";
import { fadeUp, stagger } from "@/lib/motion";
import { EXPLORE_GENRES } from "@/data";

const toneBg = {
  coral: "bg-coral/10 hover:bg-coral/16 text-coral",
  sage: "bg-sage/30 hover:bg-sage/40 text-[#4f6249] dark:bg-sage/15 dark:text-sage",
  yellow: "bg-yellow/25 hover:bg-yellow/35 text-[#8a6a29] dark:bg-yellow/15 dark:text-[#e2bd78]",
  blue: "bg-blue/18 hover:bg-blue/26 text-[#4d616c] dark:bg-blue/20 dark:text-[#aabecb]",
};

export default function BrowseGenres() {
  return (
    <section className="u-container mt-14 md:mt-20" data-testid="explore-genres">
      <SectionHeader eyebrow="Find your next mood" title="Browse by Genre" />
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }} className="mt-8 flex flex-wrap gap-2.5">
        {EXPLORE_GENRES.map((g, i) => (
          <motion.button
            key={g.key}
            type="button"
            variants={fadeUp}
            custom={i}
            onClick={() => toast(`Browsing by genre is coming soon — ${g.label} noted!`)}
            data-testid={`explore-genre-${g.key}`}
            className={cx("rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ease-soft hover:-translate-y-0.5", toneBg[g.tone])}
          >
            {g.label}
          </motion.button>
        ))}
      </motion.div>
    </section>
  );
}
